export default __webpack_public_path__ + "static/media/klickors-moe-82c8EfTvixk-unsplash.7cf63883.jpg";